import { useTranslation } from 'react-i18next'
import HomeFilter from '../components/HomeFilter'
import AnnouncesEstablishment from '../components/announces-establishment'
import ContactForm from '../components/ContactForm'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export default function EstablishmentPage() {
  const { t } = useTranslation()
  const location = useLocation()
  const [statusFilter, setStatusFilter] = useState<string | null>(null)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const status = searchParams.get('status')
    setStatusFilter(status)
  }, [location])
  return (
    <>
      <div
        id='premium-slider'
        className='text-center w-full align-middle bg-redpink text-white  py-3'
      >
        <p className='uppercase text-2xl'>{t('establishment-corner')}</p>
        <p className=''>{t('establishment-corner-desc')}</p>
      </div>

      <div
        id='announces-home'
        className='w-full mt-5 mx-auto justify-center text-anthracite'
      >
        <AnnouncesEstablishment initialStatusFilter={statusFilter} />
      </div>

      <ContactForm />
    </>
  )
}
